import {Animatable, Combined, Layer} from "../../../feature/project/Shot";
import {useAppDispatch} from "../../../feature/tools";
import {useParams} from "react-router-dom";
import {ElementContainer} from "./ElementContainer";
import React, {useCallback, useEffect, useState} from "react";
import {saveLayer} from "../../../feature/project/layerSlice";
import {AnimatableElement} from "./AnimatableElement";


export const EditElement = (props: {
    prefix: string,
    element: Layer,
    play: boolean,
    onPlayEnd: (id: number) => void,
    selectedElement: Combined & Animatable | undefined,
    scale: number,
    onMove?: (info: { x: number, y: number, z: number, scale: number }) => void,
    onElementSelected: (element: Combined | undefined) => void
}) => {
    const dispatch = useAppDispatch()
    const {projectId, storyId} = useParams()

    const [played, setPlayed] = useState<Set<number>>(new Set())
    const [play, setPlay] = useState(props.play)
    const [bound, setBound] = useState<{
        left: number | undefined,
        top: number | undefined,
        right: number | undefined,
        bottom: number | undefined
    }>({left: undefined, top: undefined, right: undefined, bottom: undefined})

    useEffect(() => {
        if ((play && played.size === (props.element.animations?.length ?? 0)) || (props.element.animations?.length === 0 && play)) {
            props.onPlayEnd(props.element.id ?? 0)
            setPlayed(new Set())
        }
    }, [played, play])

    useEffect(() => {
        setPlay(props.play)
    }, [props.play])
    const elementRef = useCallback((node: HTMLDivElement) => {
        if (!node) return;
        setBound(prev => {
            const resizeObserver = new ResizeObserver(() => {
                const rect = node.getBoundingClientRect()
                setBound(prev => {
                    return {
                        left: (!prev.left || rect.left < prev.left) ? rect.left : prev.left,
                        top: (!prev.top || rect.top < prev.top) ? rect.top : prev.top,
                        right: (!prev.right || rect.right > prev.right) ? rect.right : prev.right,
                        bottom: (!prev.bottom || rect.bottom > prev.bottom) ? rect.bottom : prev.bottom
                    }
                })
            });
            resizeObserver.observe(node);
            return {
                left: undefined,
                top: undefined,
                right: undefined,
                bottom: undefined
            }
        })

    }, [props.element.scale, props.scale]);

    return (
        <ElementContainer
            editable={true}
            key={props.prefix + props.element.id}
            isSelected={(props.selectedElement?.id === props.element.id) || false}
            scale={props.scale}
            element={props.element}
            onMove={props.onMove}
            onPositionChanged={(position) => {
                const char = {
                    ...props.element,
                    x: position.x,
                    y: position.y
                }
                if (projectId && storyId) {
                    dispatch(saveLayer({
                        projectId: parseInt(projectId),
                        storyId: parseInt(storyId),
                        layer: {...char, layers: undefined} as Layer
                    }))
                }
            }}
            size={{
                width: ((bound.right ?? 0) - (bound.left ?? 0)) / (props.scale * (props.element.scale ?? 1)),
                height: ((bound.bottom ?? 0) - (bound.top ?? 0)) / (props.scale * (props.element.scale ?? 1))
            }}
            onSelect={() => {
                props.onElementSelected(props.element)
            }}
        >
            <AnimatableElement
                element={{...props.element, x: 0, y: 0}}
                play={props.play}
                key={props.element.id}
                scale={1}
                animations={props.element.animations && props.element.animations.length > 0 ? props.element.animations : []}
                onPlayEnd={(id: number) => {
                    if (play) {
                        setPlayed(prev => new Set(prev).add(id))
                    }
                }}
            >
                <div ref={elementRef}>
                    <img src={props.element.source}
                         draggable={false}
                         unselectable={'on'}
                    />
                </div>
            </AnimatableElement>

        </ElementContainer>
    )
}